import React from 'react';
import { useTranslation } from 'react-i18next';

const TERM_STATEMENTS = [
  'Do you acknowledge that you have received, reviewed, and agree to the Consent to Receive Electronic Disclosures from Fortiva?',
  'Do you acknowledge that you have received, reviewed, and agree to the Fortiva Application Disclosures? CA Residents: If married, you may apply for a separate account.',
  'Do you acknowledge that you have received, reviewed, and agree to the Cardholder Agreement that will govern your Fortiva® Retail Credit card?',
  'Do you confirm you are at least 18 years of age, that everything you stated is true and accurate, and that you do not presently have a petition filed under federal bankruptcy laws and do not anticipate filing one? If approved, do you agree to be bound by the Fortiva Cardholder Agreement and authorize The Bank of Missouri, its successors, assigns, and agents to investigate your creditworthiness and obtain a full credit report (hard inquiry) to open your account?',
];

//Cardholder Agreement that will govern your Fortiva Retail Credit credit card.

export default function OfferTermsAndConditions({ value, onChange }) {
  const { t } = useTranslation();

  const toggle = (idx) => (e) => {
    const next = value.slice();
    next[idx] = e.target.checked;
    onChange(next);
  };

  return (
    <div className="rounded-xl border border-slate-300 bg-gradient-to-br from-slate-50 to-blue-50/40 p-5">
      <h4 className="!mt-0 !mb-2 text-sm font-bold text-gray-900">
        {t('fortiva.finalize.terms.heading')}
      </h4>
      <p className="!mt-0 !mb-3 text-xs text-gray-700 leading-snug">
        <span className="font-bold text-gray-900">Consultant: </span>
        Direct the customer to the Fortiva Retail Credit Offer Email and read each statement aloud
        to the customer and obtain their verbal consent before checking the box on their behalf.
      </p>
      <ul className="space-y-3">
        {TERM_STATEMENTS.map((statement, idx) => (
          <li key={idx} className="flex items-start gap-2 text-xs text-gray-700 leading-snug">
            <input
              type="checkbox"
              id={`fortiva-term-${idx + 1}`}
              data-testid={`fortiva-term-${idx + 1}`}
              checked={Boolean(value[idx])}
              onChange={toggle(idx)}
              className="mt-1 w-4 h-4 shrink-0 border-gray-300 rounded cursor-pointer"
            />
            <label
              htmlFor={`fortiva-term-${idx + 1}`}
              className="flex-1 cursor-pointer select-none"
            >
              <p className="!my-0 text-gray-800">
                <span className="font-bold text-gray-900">Read to customer: </span>
                &ldquo;{statement}&rdquo;
              </p>
              <div className="text-[11px] italic text-gray-400 mt-1">
                Check this box to confirm the customer verbally consented.
              </div>
            </label>
          </li>
        ))}
      </ul>
      <p
        className="mt-4 pt-3 border-t border-slate-200 text-[11px] italic text-gray-500 leading-snug"
        data-testid="monthly-payment-disclaimer"
      >
        <span aria-hidden="true">*</span>Based on your requested financing amount, your Estimated
        Initial Monthly Payment does not include payments for Promotional Financing plans. Minimum
        payments are based on your outstanding balance and may vary accordingly. Minimum payments
        will be due until you pay your balance in full. Interest will be charged to your account and
        included in your outstanding balance due.
      </p>
    </div>
  );
}
